export enum EB_ROUTES {
  EMPLOYEE_BENEFITS = "/employee-benefits",
  GPA_INSURANCE = "/employee-benefits/group-personal-accident-nsurance",
  GTL_INSURANCE = "/employee-benefits/group-term-life-insurance",
  GRP_MEDICAL_INSURANCE = "/employee-benefits/group-medical-insurance",
  EPF = "/employee-benefits/employee-provident-fund",
  ESI = "/employee-benefits/employee-state-insurance",
}
